import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Certification extends Component {
    render() {
        return (
            <Grid className="timeline-row">
                <Cell col={4} tablet={4} phone={12} className="timeline-date">
                    <p>{this.props.year}</p>
                </Cell>
                <Cell col={8} tablet={8} phone={12} className="timeline-detail">
                    <h5 className="timeline-title">{this.props.name}</h5>
                    <p>{this.props.description}</p>
                </Cell>
            </Grid>
        );
    }
}

export default Certification;
